import $ from 'jquery'
require('jquery-match-height')

const matchPostItemHeight = () => {
	$('.post-excerpt').matchHeight()
	$('.post-title').matchHeight()
}

const matchWelcomeEventsHeight = () => {
	$('.welcome-block, .events-block').matchHeight()
}

const matchFAQHeight = () => {
	$('.question-left ,.question-right').matchHeight()
}

$(document).ready(function() {
	matchPostItemHeight()
	matchWelcomeEventsHeight()
	matchFAQHeight()
})
